import React from "react";
import { Button } from "components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "components/ui/card";

const PROVIDER_STORAGE_KEY = "preferred_login_provider";

function LoginPage() {
    const handleProviderClick = (provider: "google" | "microsoft" | "salesforce") => {
        // Save preference to localStorage
        localStorage.setItem(PROVIDER_STORAGE_KEY, provider);
        // Redirect to OAuth
        window.location.href = `/login?provider=${provider}`;
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
            <Card className="w-full max-w-md shadow-lg">
                <CardHeader className="text-center space-y-2">
                    <CardTitle className="text-3xl font-bold text-gray-900">
                        Sign in to Health Harbor
                    </CardTitle>
                    <CardDescription className="text-base">
                        Choose your preferred sign-in method
                    </CardDescription>
                </CardHeader>
                <CardContent className="space-y-4 pt-6">
                    <Button
                        onClick={() => handleProviderClick("google")}
                        className="w-full h-12 text-base font-medium bg-white hover:bg-gray-50 text-gray-700 border-2 border-gray-300 shadow-sm"
                        variant="outline"
                    >
                        <svg
                            className="w-5 h-5 mr-3"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                                fill="#4285F4"
                            />
                            <path
                                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                                fill="#34A853"
                            />
                            <path
                                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                                fill="#FBBC05"
                            />
                            <path
                                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                                fill="#EA4335"
                            />
                        </svg>
                        Continue with Google
                    </Button>
                    <Button
                        onClick={() => handleProviderClick("microsoft")}
                        className="w-full h-12 text-base font-medium bg-white hover:bg-gray-50 text-gray-700 border-2 border-gray-300 shadow-sm"
                        variant="outline"
                    >
                        <svg
                            className="w-5 h-5 mr-3"
                            viewBox="0 0 23 23"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M0 0h10.5v10.5H0V0z" fill="#F25022" />
                            <path d="M12.5 0H23v10.5H12.5V0z" fill="#7FBA00" />
                            <path d="M0 12.5h10.5V23H0V12.5z" fill="#00A4EF" />
                            <path d="M12.5 12.5H23V23H12.5V12.5z" fill="#FFB900" />
                        </svg>
                        Continue with Microsoft
                    </Button>
                    <Button
                        onClick={() => handleProviderClick("salesforce")}
                        className="w-full h-12 text-base font-medium bg-white hover:bg-gray-50 text-gray-700 border-2 border-gray-300 shadow-sm"
                        variant="outline"
                    >
                        <svg
                            className="w-5 h-5 mr-3"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M19.36 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.64-4.96z"
                                fill="#00A1E0"
                            />
                        </svg>
                        Continue with Salesforce
                    </Button>
                </CardContent>
            </Card>
        </div>
    );
}

export default LoginPage;
